module.exports = __webpack_public_path__ + "static/img_1983-26106d11430f460389fab4285e42cd09.webp";